import { useEffect, useState } from "react";
import { api } from "./api";

const KEY = "mohassib:cache:";
const QUEUE = "mohassib:queue:expenses";

export const cacheGet = (k) => { try { return JSON.parse(localStorage.getItem(KEY + k)); } catch { return null; } };
export const cacheSet = (k, data) => { try { localStorage.setItem(KEY + k, JSON.stringify(data)); } catch {} };

export const queueGet = () => { try { return JSON.parse(localStorage.getItem(QUEUE)) || []; } catch { return []; } };
const queueSave = (q) => localStorage.setItem(QUEUE, JSON.stringify(q));
export const queueAdd = (payload) => {
  const item = { ...payload, _offline_id: `off-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`, _queued_at: new Date().toISOString() };
  queueSave([...queueGet(), item]);
  window.dispatchEvent(new Event("mohassib:queue"));
  return item;
};
export const queueRemove = (id) => { queueSave(queueGet().filter((x) => x._offline_id !== id)); window.dispatchEvent(new Event("mohassib:queue")); };

export const isNetworkError = (e) => !e?.response || e.code === "ERR_NETWORK" || e.response?.status === 503;

let flushing = null;
export async function flushQueue() {
  if (flushing) return flushing;
  flushing = (async () => {
    let synced = 0, failed = 0;
    for (const item of queueGet()) {
      const { _offline_id, _queued_at, ...body } = item;
      try { await api.post("/expenses", body); queueRemove(_offline_id); synced++; }
      catch (e) { if (isNetworkError(e)) break; queueRemove(_offline_id); failed++; }
    }
    if (synced || failed) window.dispatchEvent(new CustomEvent("mohassib:synced", { detail: { synced, failed } }));
    return { synced, failed };
  })();
  try { return await flushing; } finally { flushing = null; }
}

export function useOnline() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const up = () => setOnline(true), down = () => setOnline(false);
    window.addEventListener("online", up); window.addEventListener("offline", down);
    return () => { window.removeEventListener("online", up); window.removeEventListener("offline", down); };
  }, []);
  return online;
}

export function useQueue() {
  const [q, setQ] = useState(queueGet());
  useEffect(() => {
    const h = () => setQ(queueGet());
    window.addEventListener("mohassib:queue", h);
    return () => window.removeEventListener("mohassib:queue", h);
  }, []);
  return q;
}
